// removed by extract-text-webpack-plugin
module.exports = {"component":"QtOn6F7nIGyGjkAU3Xvf7","form":"_2ig59enm7p9vHbPhpNWfqm","header":"_1DPvPeoq5_9pBbKEKF_wIQ","helpText":"_2v7Nej6Uz3Q9R1JFJfb5rI","message":"G6RGATeWuJ5qsmOnrL5ag","groupStacked":"_2wuGrfK4TPRqPUorh1-PZd","label":"_3m020TwIk3DWoScJSFAKv9","control":"_1bZFldfkS-fRgHv7V4B5ou","cta":"_3fMM864OOdrByzKCL2fqjD","btn":"_2THOzv8uzYHf6vQTwv90XJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Login/ForgotPasswordDialog/ForgotPasswordDialog.css
// module id = 1067
// module chunks = 0